export default __webpack_public_path__ + "static/media/yurii_pristay.2de0f5e7.png";